import { Dictation } from '../_interfaces/dictation';

const RESUME_RETENTION_DISABLED_MESSAGE = "Audio was removed under your organisation's data retention policy, resuming is not possible";

export interface DictationRetention {
  audioDeleted: boolean;
  transcriptDeleted: boolean;
  canRecord: boolean;
  canGenerate: boolean;
  canEditPatient: boolean;
  showsDuration: boolean;
  resumeDisabledReason: string | null;
}

export function getDictationRetention(dictation: Dictation | null | undefined): DictationRetention {
  const audioDeleted = !!dictation?.audioDeletedAt;
  const transcriptDeleted = !!dictation?.transcriptionDeletedAt;

  return {
    audioDeleted,
    transcriptDeleted,
    canRecord: !audioDeleted && !transcriptDeleted,
    canGenerate: !transcriptDeleted,
    canEditPatient: !transcriptDeleted,
    showsDuration: !audioDeleted,
    resumeDisabledReason: resumeDisabledReason(audioDeleted, transcriptDeleted),
  };
}

function resumeDisabledReason(audioDeleted: boolean, transcriptDeleted: boolean): string | null {
  return audioDeleted || transcriptDeleted ? RESUME_RETENTION_DISABLED_MESSAGE : null;
}
